import { render } from "./CarriersView.vue?vue&type=template&id=6ebe161e&scoped=true"
import script from "./CarriersView.vue?vue&type=script&lang=js"
export * from "./CarriersView.vue?vue&type=script&lang=js"

import "./CarriersView.vue?vue&type=style&index=0&id=6ebe161e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebe161e"]])

export default __exports__